import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MediaTypesPage as Component } from './MediaTypesPage'
import { AppStateType } from '../../reducers'
import { selectMediaTypesSortedByExtension } from '../../selectors/mediaTypes'
import { selectAreaReadable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'

const mapStateToProps = (state: AppStateType) => {
  return {
    mediaTypes: selectMediaTypesSortedByExtension(state),
    canViewAddMediaTypePage: selectAreaReadable(state, { area: AREA_CONSTANTS.SETTINGS_CREATE_MEDIA_TYPE }),
    canViewMediaTypePrioritiesPage: selectAreaReadable(state, { area: AREA_CONSTANTS.SETTINGS_MEDIA_TYPE_PRIORITIES }),
  }
}

export const MediaTypesPage = withRouter(connect(mapStateToProps)(Component))
